const openedPaymentPage = {
  fawry: {
    title: 'การชำระเงินของคุณถูกสร้างแล้ว!',
    importantMessage: {
      title: 'สิ่งสำคัญที่ควรทราบ',
      description: 'เพื่อดำเนินการชำระเงินและหลีกเลี่ยงการยกเลิก กรุณาใช้รหัสอ้างอิงเพื่อชำระผ่านช่องทาง Fawry ร้านค้า หรือแอป Fawry ภายในเวลาที่กำหนด',
    },
    orderDetail: {
      expirationDate: 'วันหมดอายุการชำระเงิน:',
      totalAmount: 'จำนวนเงินรวม',
    },
    referenceNumber: {
      title: 'หมายเลขอ้างอิง',
      copy: 'คัดลอก',
      copied: 'คัดลอกแล้ว!',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'วันเกิด',
        validationMessage: {
          empty: 'กรุณากรอกวันเกิดของคุณ',
          invalid: 'วันเกิดไม่ถูกต้อง',
          serverError: 'เกิดข้อผิดพลาดของเซิร์ฟเวอร์ กรุณาลองอีกครั้งในภายหลัง',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'การชำระเงินด้วยสกุลเงินดิจิทัลดำเนินการโดยผู้ให้บริการภายนอกที่ได้รับอนุญาตเท่านั้น ไม่ใช่โดย EBANX รายละเอียดของผู้ให้บริการ รวมถึงใบอนุญาตและสถานะการกำกับดูแล ระบุไว้ใน ',
    termsAndConditions: 'ข้อกำหนดและเงื่อนไข',
    disclaimer2: ' ที่ใช้บังคับ',
    merchantInfo: {
      returnButton: 'คุณสามารถยกเลิกการชำระเงินนี้และกลับไปที่หน้าชำระเงินเพื่อเลือกวิธีการชำระเงินอื่น',
      backTo: 'ยกเลิกและกลับ',
    },
  },
};

module.exports = openedPaymentPage;
